// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var StringUtils = require("../StringUtils.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_LongPhoneNumber = require("./CommonTypes_LongPhoneNumber.bs.js");

function longNumber(param_0) {
  return {
          TAG: /* LongNumber */0,
          _0: param_0
        };
}

function shortCode(param_0) {
  return {
          TAG: /* ShortCode */1,
          _0: param_0
        };
}

function twilioNumber(param_0) {
  return {
          TAG: /* TwilioNumber */2,
          _0: param_0
        };
}

var shortCodeRegex = /^[0-9]{5}$/;

var twilioNumberRegex = /^MG([A-z]|[0-9]){32}$/;

function getMaybeNumberTypeCriteria(maybePhoneNumber) {
  return {
          isShortCode: shortCodeRegex.test(maybePhoneNumber),
          isTwilioNumber: twilioNumberRegex.test(maybePhoneNumber),
          longNumber: CommonTypes_LongPhoneNumber.fromString(maybePhoneNumber)
        };
}

function fromString(maybePhoneNumber) {
  var match = getMaybeNumberTypeCriteria(maybePhoneNumber);
  var longNumber = match.longNumber;
  if (longNumber !== undefined) {
    return Relude_Option.pure({
                TAG: /* LongNumber */0,
                _0: longNumber
              });
  } else if (match.isShortCode) {
    return Relude_Option.pure({
                TAG: /* ShortCode */1,
                _0: maybePhoneNumber
              });
  } else if (match.isTwilioNumber) {
    return Relude_Option.pure({
                TAG: /* TwilioNumber */2,
                _0: maybePhoneNumber
              });
  } else {
    return ;
  }
}

function fromString$1(maybePhoneNumber) {
  return Curry._2(Relude_Option.Infix.$less$pipe$great, Curry._2(Relude_Option.Infix.$less$pipe$great, Curry._2(Relude_Option.Infix.$less$pipe$great, fromString(maybePhoneNumber), fromString(StringUtils.getNumbersOnly(maybePhoneNumber))), fromString("+" + StringUtils.getNumbersOnly(maybePhoneNumber))), fromString("+1" + StringUtils.getNumbersOnly(maybePhoneNumber)));
}

function toString(longNumber) {
  switch (longNumber.TAG | 0) {
    case /* LongNumber */0 :
        return CommonTypes_LongPhoneNumber.toString(longNumber._0);
    case /* ShortCode */1 :
    case /* TwilioNumber */2 :
        return longNumber._0;
    
  }
}

function toFormattedString(longNumber) {
  switch (longNumber.TAG | 0) {
    case /* LongNumber */0 :
        return CommonTypes_LongPhoneNumber.toFormattedString(longNumber._0);
    case /* ShortCode */1 :
    case /* TwilioNumber */2 :
        return longNumber._0;
    
  }
}

function toLongNumber(longNumber) {
  switch (longNumber.TAG | 0) {
    case /* LongNumber */0 :
        return Relude_Option.pure(longNumber._0);
    case /* ShortCode */1 :
    case /* TwilioNumber */2 :
        return ;
    
  }
}

var compare = Curry._1(Relude_String.compareWithConversion, toString);

var eq = Curry._1(Relude_String.eqWithConversion, toString);

var decode = Curry._1(Json.Decode.variantFromString, fromString$1);

function encode(param) {
  return Relude_Globals.$great$great(toString, (function (prim) {
                return prim;
              }), param);
}

var $$default = Relude_Option.getOrThrow(fromString$1("+15555551234"));

function parse(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(decode, Relude_Result.getOk, param);
              }), Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: encode
};

function parse$1(param) {
  return Relude_Globals.$great$great(fromString$1, Relude_Option.getOrThrow, param);
}

var GraphQL_API_FromString = {
  parse: parse$1,
  serialize: toString
};

var fromLongNumber = longNumber;

exports.longNumber = longNumber;
exports.shortCode = shortCode;
exports.twilioNumber = twilioNumber;
exports.shortCodeRegex = shortCodeRegex;
exports.twilioNumberRegex = twilioNumberRegex;
exports.fromString = fromString$1;
exports.toString = toString;
exports.toFormattedString = toFormattedString;
exports.toLongNumber = toLongNumber;
exports.fromLongNumber = fromLongNumber;
exports.compare = compare;
exports.eq = eq;
exports.decode = decode;
exports.encode = encode;
exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
exports.GraphQL_API = GraphQL_API;
exports.GraphQL_API_FromString = GraphQL_API_FromString;
/* compare Not a pure module */
